import React from "react";

export default function SizeFacet({ handleFilterClick, productSize }) {
  const wpProductCategory = window.wpProductCategory;
  const plpFacetLabel = wpProductCategory.plpFacetLabel;
  const title =
    plpFacetLabel &&
    Object.keys(plpFacetLabel)?.length > 0 &&
    plpFacetLabel.hasOwnProperty("size_facet") &&
    plpFacetLabel.size_facet != ""
      ? plpFacetLabel.size_facet
      : "Size";
  return (
    <div class="facet-wrap facet-display">
      <strong>{title}</strong>
      <div className="facetwp-facet">
        {Object.keys(productSize).map((size, i) => {
          if (size && productSize[size] > 0) {
            return (
              <div>
                <span
                  id={`size-filter-${i}`}
                  key={i}
                  data-value={`${size.toLowerCase()}`}
                  onClick={(e) =>
                    handleFilterClick("size_facet", e.target.dataset.value)
                  }>
                  {" "}
                  {size} {` (${productSize[size]}) `}
                </span>
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}
